import { Button } from "@mui/material";
import { LayoutGrid, ListPlus, Sparkles } from "lucide-react";

interface AnalyticsHeaderProps {
  title: string;
  facetCount: number;
  onAddFacetManually: () => void;
  onGenerateFacet: () => void;
  generateFacetLoading?: boolean;
  /** When set, show data-bank context and hide facet action buttons. */
  dataBankSubtitle?: string | null;
}

export default function AnalyticsHeader({
  title,
  facetCount,
  onAddFacetManually,
  onGenerateFacet,
  generateFacetLoading = false,
  dataBankSubtitle = null,
}: AnalyticsHeaderProps) {
  const dataBankView = Boolean(dataBankSubtitle);
  return (
    <div className="w-full p-4 bg-[#f9fafb]">

      <div className="flex items-center justify-between w-full bg-white border border-[#e5e7eb] rounded-[50px] p-2 pr-3 shadow-sm">
      
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#f24495] text-white shadow-sm ml-1">
            <LayoutGrid size={22} strokeWidth={2} />
          </div>
          
          <div className="flex flex-col">
            <h1 className="text-[15px] font-bold leading-tight text-[#111827]">
              {title}
            </h1>
            <span className="text-[13px] text-gray-400 font-medium">
              {dataBankSubtitle ?? `${facetCount} Facets`}
            </span>
          </div>
        </div>

        {!dataBankView && (
        <div className="flex items-center gap-2">
          <Button
            onClick={onAddFacetManually}
            startIcon={<ListPlus size={18} />}
            sx={{
              textTransform: "none",
              borderRadius: "40px",
              backgroundColor: "#f1f1f1",
              color: "#1f2937",
              px: 3,
              py: 1.2,
              fontWeight: 600,
              fontSize: "13px",
              "& .MuiButton-startIcon": { mr: 1 },
              "&:hover": { 
                backgroundColor: "#e5e7eb",
                boxShadow: "none" 
              },
            }}
          >
            Add Facet Manually
          </Button>

          <Button
            variant="contained"
            onClick={onGenerateFacet}
            disabled={generateFacetLoading}
            startIcon={<Sparkles size={18} />}
            sx={{
              textTransform: "none",
              borderRadius: "40px",
              background: "linear-gradient(90deg, #2563eb 0%, #c026d3 100%)",
              color: "#fff",
              px: 3,
              py: 1.2,
              fontWeight: 600,
              fontSize: "13px",
              boxShadow: "0 4px 12px rgba(37, 99, 235, 0.2)",
              "& .MuiButton-startIcon": { mr: 1 },
              "&:hover": {
                background: "linear-gradient(90deg, #1d4ed8 0%, #a21caf 100%)",
                boxShadow: "0 6px 16px rgba(37, 99, 235, 0.3)",
              },
            }}
          >
            Generate Facet Automatically
          </Button>
        </div>
        )}
      </div>
    </div>
  );
}
